import styled, { css } from "styled-components"

import { minWidth } from "utils"

import Icon from "icons"
import AccordionItem from "components/accordion-item"

export const Wrapper = styled.div`
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem;
  padding-bottom: 4rem;

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
  `}
`

export const Accordion = styled(AccordionItem)`
  width: 100%;

  summary > div {
    border-color: #b5471f;
  }
`
export const ItemList = styled.ol`
  margin-top: 0;
  padding-top: 0;
`
export const Item = styled.li`
  padding: 0 1.5rem 1.3rem;
  line-height: 1.45;

  &::marker {
    font-weight: 500;
  }
`

export const CitationLink = styled.a`
  font-weight: 500;
  line-height: 1.375;
  letter-spacing: -0.1rem;
  text-decoration: underline;
  overflow-wrap: anywhere;
  color: #b5471f;
`

export const ModalWrapper = styled.div`
  position: relative;
  z-index: 1200;
  width: 33rem;

  ${minWidth.tablet`
    width: 41.2rem;
  `}
`

export const HoverContainer = styled.div`
  height: 2rem;
  display: none;

  ${minWidth.tablet`
    display: block;
  `}
`

export const Modal = styled.div`
  width: 100%;
  padding: 2rem;
  display: flex;
  border: 1px solid #b5471f;
  border-radius: 0.6rem;
  background-color: #fff;
  color: ${({ theme }) => theme.colors.text.primary};
  box-shadow: 6px 6px 1px 0 #b5471f;
  pointer-events: all;
`

export const CloseIconWrapper = styled.div`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  color: #b5471f;
  cursor: pointer;
  transition: color 0.15s linear;

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
  }

  ${minWidth.tablet`
    display: none;
  `}
`

export const CheckIcon = styled(Icon)`
  color: #b5471f;
`

export const Content = styled.div`
  width: calc(100% - 4.5rem);
  padding-left: 1.3rem;
`

export const Supertitle = styled.div`
  margin-bottom: 0.8rem;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.0833;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
`

export const Title = styled.div`
  margin-bottom: 0.8rem;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 2rem;
  font-weight: 500;
  line-height: 1.35;
`

export const Description = styled.div`
  margin-bottom: 1.2rem;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.6rem;
  line-height: 1.125;
`

export const SourceLink = styled.a`
  font-size: 1.6rem !important;
  font-weight: 500 !important;
  line-height: 1.0625 !important;
  text-decoration: none !important;
  color: #b5471f;
  transition: color 0.15s linear;

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
  }
`

export const ArrowIcon = styled(Icon)`
  position: relative;
  top: 0.3rem;
  left: 0.5rem;
`

export const Background = styled.div`
  position: fixed;
  z-index: 1100;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;

  ${minWidth.tablet`
    display: none;
  `}
`

export const citationStyles = css`
  [data-citation-link] {
    color: #b5471f;
    cursor: pointer;
  }

  [data-citation-number] {
    position: relative;
    padding-left: 0.4rem;
    top: -0.8rem;
    font-size: 1.4rem;
    text-decoration: none;

    svg {
      margin-left: 0.2rem;

      path {
        fill: #b5471f;
      }
    }
  }
`
